import { useState, useEffect, forwardRef, useImperativeHandle } from 'react';
import { ROLE } from './CounselingTextBox';

interface CounselingRoleSelectboxProps {
  value: string;
  stopEditing: () => void;
  api: any; // Ag-Grid API
  node: any; // Ag-Grid Node (Row 정보)
  column: any; // 현재 컬럼 정보
}

const CounselingRoleSelectbox = forwardRef(
  ({ value: initialValue, stopEditing, api, node, column }: CounselingRoleSelectboxProps, ref) => {
    const [value, setValue] = useState(initialValue);

    // useEffect(() => {
    //   setValue(initialValue);
    // }, [initialValue]);

    const handleChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
      const newValue = event.target.value;
      setValue(newValue);

      const selectedRow = api.getRowNode(node.id);

      if (!selectedRow) {
        console.warn('Row node not found!', node.id);
        return;
      }

      selectedRow.setDataValue(column.colId, newValue);
      api.refreshCells({ rowNodes: [selectedRow], columns: [column.colId], force: true });

      stopEditing();
    };

    return (
      <select
        value={value}
        onChange={handleChange}
        autoFocus
        className="w-full hg-4/5 px-3 py-2 border rounded-[4px] shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition duration-200 bg-white text-gray-700 hover:bg-gray-50"
      >
        {Object.entries(ROLE).map(([key, value]) => (
          <option key={key} value={key}>
            {value}
          </option>
        ))}
      </select>
    );
  },
);

export default CounselingRoleSelectbox;
